import { toast } from "react-toastify";
import apiCall from "../api/Api";
import { appendSortParams } from "../utils/sortParams";

const NotificationService = {
  getNotification: async ({
    searchTerm = "",
    page = 1,
    perPage = 10,
    filters = {},
    sortBy = null,
    sortOrder = null,
  } = {}) => {
    try {
      const params = new URLSearchParams();

      params.append("page", page);
      params.append("per_page", perPage);

      if (filters?.recipientCategory) {
        params.append("recipient_category", filters.recipientCategory);
      }

      if (filters?.recipientCategory === "geek" && filters?.geekType) {
        params.append("geek_type", filters.geekType);
      }

      if (filters?.dateFrom) {
        params.append("date_from", filters.dateFrom);
      }

      if (filters?.dateTo) {
        params.append("date_to", filters.dateTo);
      }

      if (filters?.notificationType) {
        params.append("notification_type", filters.notificationType);
      }

      if (filters?.sentBy) {
        params.append("sent_by", filters.sentBy);
      }

      if (searchTerm?.trim()) {
        params.append("search", searchTerm.trim());
      }

      appendSortParams(params, sortBy, sortOrder);

      const url = `get-all-notifications?${params.toString()}`;
      return await apiCall("GET", url);
    } catch (error) {
      toast.error(error?.userMessage || "Failed to fetch notifications");
      throw error;
    }
  },
  
  getNotificationDetail: async (id) => {
    try {
      return await apiCall("GET", `show-notification/${id}`);
    } catch (error) {
      toast.error(error?.userMessage || "Failed to fetch notification detail");
      throw error;
    }
  },

  getRecipients: async (recipientType) => {
    try {
      return await apiCall("POST", "recipients/all", {
        recipient_type: recipientType,
      });
    } catch (error) {
      toast.error(error?.userMessage || "Failed to fetch recipients");
      throw error;
    }
  },

  sendNotification: async (payload) => {
    try {
      return await apiCall("POST", "send-notification", payload);
    } catch (error) {
      toast.error(error?.userMessage || "Failed to send notification");
      throw error;
    }
  },

  // Push notification fired alongside an admin chat message, mirroring the
  // customer portal (store/booking/sagas.js sendChatNotification). Deliberately
  // does NOT toast on failure: the Firestore write has already landed by the
  // time this runs, so the message IS sent — surfacing an error toast here
  // would read as "your message failed" when only the push did. Callers log.
  sendChatNotification: async (payload) => {
    return await apiCall("POST", "send-chat-notification", payload);
  },

  getAdminNotifications: async () => {
    try {
      return await apiCall("GET", "notifications?user_id=1");
    } catch (error) {
      toast.error(error?.userMessage || "Failed to fetch notifications");
      throw error;
    }
  },

  markNotificationAsRead: async (notificationId) => {
    try {
      return await apiCall("POST", `seen-notification/${notificationId}`, {
        notification_id: notificationId,
      });
    } catch (error) {
      toast.error(error?.userMessage || "Failed to mark notification as read");
      throw error;
    }
  },
};

export default NotificationService;
